function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 322.777h512v22.261H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 300.516h512v22.261H0zm0 44.522h512v22.261H0z",
  fill: "#f0f0f0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M180.384 261.272l3.004 9.249h9.725l-7.867 5.715 3.005 9.248-7.867-5.715-7.867 5.715 3.005-9.248-7.866-5.715h9.724zm0 121.06l3.004 9.247h9.725l-7.867 5.715 3.005 9.248-7.867-5.715-7.867 5.715 3.005-9.248-7.866-5.715h9.724zm-56.351-40.943l3.004 9.249h9.725l-7.866 5.715 3.004 9.248-7.867-5.715-7.867 5.715 3.005-9.248-7.867-5.715h9.725zm21.524-68.011l3.004 9.248h9.725l-7.866 5.716 3.004 9.248-7.867-5.716-7.867 5.716 3.005-9.248-7.867-5.716h9.725zm-34.253 38.084l9.723.001 3.005-9.249 3.005 9.248 9.725-.001-7.867 5.716 3.005 9.25-7.868-5.716-7.866 5.713 3.004-9.247zm26.386 81.209l3.005-9.246-7.868-5.717h9.725l3.005-9.248 3.005 9.247h9.724l-7.867 5.716 3.004 9.249-7.867-5.716zm99.024-51.282l-3.004 9.249h-9.724l7.865 5.715-3.004 9.248 7.867-5.715 7.867 5.715-3.005-9.248 7.867-5.715h-9.725zm-21.524-68.011l-3.004 9.248h-9.725l7.866 5.716-3.004 9.248 7.867-5.716 7.867 5.716-3.005-9.248 7.867-5.716h-9.725zm34.253 38.084l-9.722.001-3.006-9.249-3.005 9.248-9.724-.001 7.867 5.716-3.006 9.25 7.868-5.716 7.866 5.713-3.004-9.247zm-26.386 81.209l-3.005-9.246 7.867-5.717h-9.724l-3.005-9.248-3.005 9.247h-9.724l7.867 5.716-3.004 9.249 7.867-5.716z",
  fill: "#ffda44"
});

const SvgCapeVerde = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCapeVerde, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cape-verde.f0b2f3dc.svg";
export { ForwardRef as ReactComponent };